/**
 * CANDIDATE-PORTAL DARK EDITORIAL THEME (Mark, 2026-08-01: "a revamp of the
 * portal look — much more impressive and professional").
 *
 * One system, shared by every portal-home component: the brand's navy
 * letterhead brought to the screen — the login page's gradient field, gold
 * hairlines, serif display, cards as raised navy panels. Every HEX here is
 * from the approved motif palette (scripts/check-motif-colors.mjs); all dark
 * surface/text variants are rgba layers of approved colors, which is the
 * established pattern (GOLD_MUTED predates this file).
 *
 * Semantics, not literals: `WHITE` is the CARD SURFACE token (it was the
 * card background in the light system and keeps that role here), `TEXT` is
 * ink-on-surface. Do not "fix" the names — 2,000+ lines of components key
 * off them.
 */

// ── Brand anchors (approved hex) ─────────────────────────────────────
export const NAVY = '#091525'
export const NAVY_LIGHT = '#152A42' // gradient/hover accent (approved "navy mid")
export const GOLD = '#DFC06A'
export const GOLD_DEEP = '#C7A84F'
export const GOLD_SOFT = '#F0D89C'
export const GOLD_MUTED = 'rgba(223,192,106,0.12)'

// ── Page + surfaces ──────────────────────────────────────────────────
/** The login page's exact atmosphere — the portal lives on the letterhead. */
export const PAGE_BG = 'linear-gradient(135deg, #091525 0%, #091525 55%, #152A42 100%)'
export const BG = 'transparent' // sections sit directly on the page field
export const WHITE = 'rgba(255,255,255,0.045)' // card surface (raised navy panel)
export const CARD_RAISED = 'rgba(255,255,255,0.07)'
export const GRAY_BG = 'rgba(9,21,37,0.45)' // inset wells within cards
export const CREAM = '#FFFBEB'

// ── Ink ──────────────────────────────────────────────────────────────
export const TEXT = 'rgba(255,255,255,0.94)'
export const TEXT_SECONDARY = 'rgba(255,255,255,0.66)'
export const GRAY_TEXT = 'rgba(255,255,255,0.45)'

// ── Lines ────────────────────────────────────────────────────────────
export const BORDER = 'rgba(255,255,255,0.09)'
export const GRAY_BORDER = 'rgba(255,255,255,0.09)'
export const BORDER_GOLD = 'rgba(223,192,106,0.30)'

// ── Status (dark-compatible layers of approved status colors) ────────
export const GREEN = '#D1FAE5'
export const GREEN_BG = 'rgba(15,123,87,0.20)'
export const GREEN_BORDER = 'rgba(15,123,87,0.45)'
export const AMBER = '#F0D89C'
export const AMBER_BG = 'rgba(223,192,106,0.08)'
export const AMBER_BORDER = 'rgba(223,192,106,0.28)'

// ── Signature elements ───────────────────────────────────────────────
/** Compass-rose watermark for the hero — the letterhead's mark, oversized. */
export const LOGO_WHITE = '/meridian-anesthesia-logo-white-clean.svg'
